import EditableText from './EditableText.vue';
import Input from './Input.vue';
import NumberInput from './NumberInput.vue';
import VisualTextEditor from './VisualTextEditor.vue';

export default [
  EditableText,
  Input,
  NumberInput,
  VisualTextEditor,
];
